module.exports = __webpack_public_path__ + "img/paypal-admin.61bbc435.svg";